import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNetherlands = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 256,
			cy: 256,
			r: 256,
			fill: "#f0f0f0"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#a2001d",
			d: "M256 0A256 256 0 0 0 16 167h480A256 256 0 0 0 256 0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0052b4",
			d: "M256 512a256 256 0 0 0 240-167H16a256 256 0 0 0 240 167z"
		})
	]
});
export default SvgNetherlands;
